import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import useAction from '@/hooks/useAction'
import { useCrud } from '@/hooks/useCrud'
import { camelToWords } from '@/utils/stringHelper'
import ConfigService from './config.service'
import { createQueryKey } from '@/lib/react-query'
import { API_RESOURCE } from '@/constants/api.constant'

const useConfig = () => {
  const service = new ConfigService()
  const baseCrud = useCrud(API_RESOURCE.CONFIG, service)

  const queryClient = useQueryClient()
  const queryKey = createQueryKey(API_RESOURCE.CONFIG)

  const useFetchConfigByType = (type) => {
    return useQuery({
      queryKey: [...queryKey.details(), type],
      queryFn: () => service.fetchConfigByType(type),
      placeholderData: keepPreviousData,
    })
  }
  const useFetchConfigDefaultUser = (type) => {
    return useQuery({
      queryKey: [...queryKey.details(), type],
      queryFn: () => service.getDefaultUserByType(type),
      placeholderData: keepPreviousData,
      select: (result) => result?.data,
    })
  }

  const useBatchUpdateConfigs = () => {
    return useMutation({
      mutationFn: service.batchUpdateConfigs,
      onSuccess: (res) => {
        toast.info(`Successfully Batch Update ${camelToWords(API_RESOURCE.CONFIG)}`)
        queryClient.invalidateQueries(queryKey.lists())
      },
    })
  }

  const useFetchAllConfigByCategory = (category) => {
    return useQuery({
      queryKey: [...queryKey.list({}), category],
      queryFn: () => service.fetchAllConfigByCategory(category),
      placeholderData: [],
    })
  }

  const useUpdateTestingConfig = useAction({
    mutationFn: service.updateTestingConfig,
    queryKey: queryKey,
    message: 'Successfully Update Testing Config',
  })

  return {
    //Base CRUD
    useFetchAllConfigs: baseCrud.useFetchAll,
    useFetchConfig: baseCrud.useFetchOne,
    useCreateConfig: baseCrud.useCreate,
    useUpdateConfig: baseCrud.useUpdate,
    useRemoveConfig: baseCrud.useRemove,

    //Extra
    useFetchConfigByType,
    useBatchUpdateConfigs,
    useFetchAllConfigByCategory,
    useUpdateTestingConfig,
    useFetchConfigDefaultUser,
  }
}

export default useConfig
